import { Product } from "@/domain/product"
import { Seller } from "@/domain/seller"
import { zeroPad } from "./number-utils"

export function productNumber(seller: Seller, product: Product) {
  return zeroPad(seller.id, 6) + '-' + zeroPad(product.number, 6)
}
